<template>
  <div
    class="admin-changelog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="admin-changelog-title"
    tabindex="-1"
    @keydown="handleKeydown"
  >
    <div
      class="admin-changelog__backdrop admin-button--ghost"
      @click="dismiss"
    ></div>
    <section ref="panel" class="admin-changelog__panel" tabindex="-1">
      <header class="admin-changelog__header">
        <div>
          <p class="admin-kicker">Neuigkeiten</p>
          <h2 id="admin-changelog-title" class="admin-changelog__title">
            Versionshinweise {{ version }}
          </h2>
        </div>
        <button
          ref="closeButton"
          type="button"
          class="admin-button--ghost admin-button--icon"
          aria-label="Versionshinweise schließen"
          @click="dismiss"
        >
          <span aria-hidden="true">×</span>
        </button>
      </header>
      <div class="admin-changelog__body" v-html="safeMarkdown"></div>
      <footer class="admin-changelog__footer">
        <button type="button" class="admin-button--primary" @click="dismiss">
          Schließen
        </button>
      </footer>
    </section>
  </div>
</template>

<script>
import { computed, nextTick, onBeforeUnmount, onMounted, ref } from "vue";
import DOMPurify from "dompurify";
import { marked } from "marked";

export default {
  name: "AdminChangelogModal",
  props: {
    version: {
      type: String,
      default: "",
    },
    markdown: {
      type: String,
      default: "",
    },
  },
  emits: ["dismiss"],
  setup(props, { emit }) {
    const closeButton = ref(null);
    let previousBodyOverflow = "";

    const safeMarkdown = computed(() =>
      DOMPurify.sanitize(marked.parse(props.markdown || ""))
    );

    function dismiss() {
      emit("dismiss");
    }

    function focusableElements(container) {
      return Array.from(
        container?.querySelectorAll(
          '.admin-changelog__panel a[href], .admin-changelog__panel button:not([disabled]), .admin-changelog__panel [tabindex]:not([tabindex="-1"])'
        ) || []
      );
    }

    function handleKeydown(event) {
      if (event.key === "Escape") {
        dismiss();
        return;
      }
      if (event.key !== "Tab") return;

      const elements = focusableElements(event.currentTarget);
      if (!elements.length) return;
      const first = elements[0];
      const last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    onMounted(() => {
      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      nextTick(() => closeButton.value?.focus());
    });

    onBeforeUnmount(() => {
      document.body.style.overflow = previousBodyOverflow;
    });

    return {
      closeButton,
      safeMarkdown,
      dismiss,
      handleKeydown,
    };
  },
};
</script>
